// Named SFX presets for Marshmallow Madness. Each function takes an
// AudioContext + output node and schedules a short sound. Call sites use
// these names so SFX can be swapped for loaded samples later without
// touching gameplay code.
//
// Catalog:
//   sfxDing      perfect toast complete        bright ascending chord
//   sfxBurn      marshmallow burnt             crackle + low thump
//   sfxGameOver  run ends (game over)          descending arpeggio + noise fade

import { beep, chord, noiseBurst, sweep } from './synth';

/** Bright celebratory chord: marshmallow perfectly toasted. */
export function sfxDing(ctx: AudioContext, out: AudioNode): void {
  const now = ctx.currentTime;
  // C major-7 chord (C5 E5 G5 B5) — warm and triumphant.
  chord(
    ctx,
    out,
    {
      freqs: [523.25, 659.25, 783.99, 987.77],
      duration: 0.28,
      gain: 0.32,
      wave: 'triangle',
    },
    now,
  );
  // Sparkle sweep up from G5 to G6.
  sweep(
    ctx,
    out,
    { fromFreq: 783.99, toFreq: 1567.98, duration: 0.2, gain: 0.12, wave: 'sine' },
    now + 0.1,
  );
}

/** Char crackle: marshmallow burnt. */
export function sfxBurn(ctx: AudioContext, out: AudioNode): void {
  const now = ctx.currentTime;
  noiseBurst(ctx, out, { duration: 0.28, lowpass: 700, gain: 0.22 }, now);
  sweep(
    ctx,
    out,
    { fromFreq: 200, toFreq: 55, duration: 0.32, gain: 0.18, wave: 'sawtooth' },
    now,
  );
}

/** Descending arpeggio + noise fade: run over. */
export function sfxGameOver(ctx: AudioContext, out: AudioNode): void {
  const now = ctx.currentTime;
  // G4 → E4 → C4 → A3 descending.
  beep(ctx, out, { freq: 392.0, duration: 0.14, gain: 0.22, wave: 'triangle' }, now);
  beep(ctx, out, { freq: 329.63, duration: 0.14, gain: 0.22, wave: 'triangle' }, now + 0.18);
  beep(ctx, out, { freq: 261.63, duration: 0.14, gain: 0.22, wave: 'triangle' }, now + 0.36);
  beep(ctx, out, { freq: 220.0, duration: 0.3, gain: 0.22, wave: 'triangle' }, now + 0.54);
  noiseBurst(ctx, out, { duration: 0.9, lowpass: 350, gain: 0.12 }, now);
}
